import { useRef, useState } from 'react'
import { Input, Modal } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import { IconListDetails } from '@tabler/icons-react'

interface CreatePriceListModalProps {
  modalRef: React.RefObject<HTMLDialogElement>
  onConfirm: (name: string) => void
  isLoading?: boolean
}

export function useCreatePriceListModal() {
  const modalRef = useRef<HTMLDialogElement>(null)
  const show = () => modalRef.current?.showModal()
  const close = () => modalRef.current?.close()
  return { modalRef, show, close }
}

export function CreatePriceListModal({ modalRef, onConfirm, isLoading }: CreatePriceListModalProps) {
  const [name, setName] = useState('')

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!name.trim()) return
    onConfirm(name.trim())
  }

  return (
    <Modal ref={modalRef} className="bg-neutral">
      <Modal.Header>
        <div className="flex flex-col items-center gap-3 pt-2">
          <div className="bg-primary bg-opacity-20 text-primary rounded-full p-4">
            <IconListDetails size={36} />
          </div>
          <span className="text-xl font-bold text-center">Neue Preisliste erstellen</span>
        </div>
        <form method="dialog">
          <button className="btn btn-sm btn-circle btn-ghost absolute right-5 top-5">✕</button>
        </form>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <label className="form-control w-full">
            <div className="label">
              <span className="label-text">Name der Preisliste</span>
            </div>
            <Input
              placeholder="z.B. Premium Hochzeit"
              value={name}
              onChange={e => setName(e.target.value)}
              required
              autoFocus
            />
          </label>
          <div className="flex flex-row gap-3 justify-center">
            <form method="dialog">
              <Button type="button" color="ghost" disabled={isLoading}
                onClick={() => modalRef.current?.close()}>
                Abbrechen
              </Button>
            </form>
            <Button type="submit" color="primary" loading={isLoading} disabled={isLoading || !name.trim()}>
              Erstellen
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}
